<div>
  <form [formGroup]="partnerUrlForm">
    <small class="my-5" translate>partner_setup_link_description</small>
    <div class="page__form-wrap">
      <div class="form-group row custom-margin">
        <label for="partner-url" class="col-sm-4 label-position" translate>partner_setup_link_title</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" id="urlPartner" formControlName="partnerUrl" readonly="true"/>
        </div>
      </div>
    </div>
  </form>
</div>

